






























































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import { Component, Vue, PropSync, Watch, Prop } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { safetyAndEnvironmentAssessmentServer } from '@/api/installServer';
import DepartmentsAndOfficesAddPages from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/departmentsAndOfficesAddPages.vue';
import ViewPages from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/viewPages.vue';
import AssessmentPageComponent from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/assessmentPageComponent.vue';
@Component({
  components: { DepartmentsAndOfficesAddPages, CollapseTransition, ViewPages, AssessmentPageComponent },
  mixins: [TableStripe],
})
export default class SafetyAndEnvironmentAssessment extends Vue {
  @Prop(Object) row!: any; // 传递给编辑页面-数据对象
  activeName: any = '';

  private editRoleFlag: any = 1; // 控制显示 考核 页面
  private rowInner: any = {}; // 控制显示 编辑 页面

  // table 数据对象
  tableData: any = [];
  header: any = [];

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    console.log(this.row);
    this.activeName = this.row.assessType;
    // 获取分页数据
    this.getPageData();
  }

  // 创建开始点击事件
  createExam(data?: any) {
    this.rowInner = data; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 2; // 进入编辑页面
  }

  returnLastPage() {
    this.$emit('on-response');
  }

  // 查看
  viewManagement(data: any) {
    this.rowInner = data; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 3; // 进入编辑页面
  }

  /**
   * @desc 获取安全环保所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    // 发起接口请求，获取分页数据
    safetyAndEnvironmentAssessmentServer
      .getviewSeasonByQuarterly(this.row)
      .then((res: any) => {
        console.log(res.data);
        this.tableData = res.data;
        // for (const item of this.tableData) {
        //   let leave = item.get;
        //   this.header = Object.keys(leave);
        // }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  // 考核
  assessmentPage(data: any) {
    // this.row = data; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 4; // 进入编辑页面
  }

  private handleMenuEditResponse() {
    this.editRoleFlag = 1;
    // 获取分页数据
    this.getPageData();
  }
}
